import axios from "axios";
import constants from "constants";
import { store } from "store";
import errorHandler from "./errorHandler";
/*
    TODO Write a network layer before axios,
    Handle cancellation of network call or ignoring stale response
    Camelize all api keys at deep level
*/

const appService = axios.create({
  baseURL: constants.appServiceUrl,
});

appService.interceptors.request.use((config) => {
  const userInfo = store.getState().userInfo;
  config.headers[constants.authTokenBackendKey] = userInfo.authToken;
  config.headers["Authorization"] = `Bearer ${userInfo.authToken}`;
  config.headers["sessionID"] = userInfo.sessionId;
  return config;
});

appService.interceptors.response.use(function (response) {
  return response;
}, errorHandler);

export default appService;
